import { Avatar, Button } from '@radix-ui/themes'
import { IconCheck, IconExclamationMark } from '@tabler/icons-react'
import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { useLocation, useNavigate } from 'react-router'
import { deleteIntegration, updateIntegrationsConfig } from '../../reducers/integrations'
import { useAppDispatch } from '../../reducers/store'
import { DEFAULT_TOAST_CONFIG } from '../toast/consts'

function MtdCompleteWrapper() {
  const di = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const tenantId = params.get('tenant')
  const error = params.get('error')

  useEffect(() => {
    if (!error && tenantId && tenantId.length > 0) {
      saveMtdIntegrationSettings()
    } else {
      removeIntegration()
    }
  }, [error, tenantId])

  const saveMtdIntegrationSettings = async () => {
    const formData = []
    formData.push(
      { serverValue: 'tenant_id', value: tenantId },
      { serverValue: 'active', value: 'true' },
      { serverValue: 'state', value: 'OPEN' },
      { serverValue: 'failure_count', value: '0' }
    )

    const payload = {
      integrationValues: JSON.stringify(formData),
      integrationServerValue: 'intune_mtd',
    }

    const [successful, response] = await di(updateIntegrationsConfig(payload))

    if (successful) {
      toast.success('Intune MTD integration configured successfully', DEFAULT_TOAST_CONFIG)
    } else {
      if (response !== undefined) {
        toast.error(response, DEFAULT_TOAST_CONFIG)
      } else {
        toast.error('Failed to configure Intune MTD integration', DEFAULT_TOAST_CONFIG)
      }
    }
  }

  const removeIntegration = async () => {
    await di(deleteIntegration({ integrationServerValue: 'intune_mtd' }))
  }

  return (
    <div className="h-screen light dark:dark flex">
      <div className="flex flex-col items-center justify-center text-center w-full gap-8">
        <div className="flex flex-col items-center">
          {!error && (
            <>
              <Avatar radius="full" color="green" fallback={<IconCheck size={40} />} size="6" />
              <p className="max-w-[500px] text-center font-semibold text-black dark:text-white text-2xl mt-6">
                Integration Connected
              </p>
              <div className="text-center justify-center text-black text-md font-normal mt-2">
                Microsoft MTD has been successfully
                <br />
                connected to your organisation
              </div>
              <div className="flex gap-4 mt-6">
                <Button
                  className="h-[38px] bg-surfaceSecondary outline outline-1 outline-mainBorder text-mainText cursor-pointer hover:opacity-70"
                  onClick={() => navigate('/integrations')}
                >
                  Back to Integrations
                </Button>
                <Button
                  className="h-[38px] bg-PurpleBlue-9 dark:bg-mainPurple hover:bg-PurpleBlue-10 dark:hover:bg-tertiaryPurple active:bg-PurpleBlue-10 dark:active:bg-tertiaryPurple cursor-pointer"
                  onClick={() => navigate('/device-policies')}
                >
                  Continue to Policies
                </Button>
              </div>
            </>
          )}
          {error && (
            <>
              <Avatar radius="full" color="red" fallback={<IconExclamationMark size={40} />} size="6" />
              <p className="max-w-[500px] text-center font-semibold text-black dark:text-white text-2xl mt-6">
                Something went wrong
              </p>
              <div className="text-center justify-center text-black text-md font-normal mt-2">
                We have been unable to connect Microsoft MTD to your
                <br />
                organization at this time. Please try again, and if the
                <br />
                error persists contact us at{' '}
                <a href="mailto:support@iverify.io" target="_blank" className="text-mainPurple font-semibold">
                  support@iverify.io
                </a>
              </div>
              <div className="flex gap-4 mt-6">
                <Button
                  className="h-[38px] bg-surfaceSecondary outline outline-1 outline-mainBorder text-mainText cursor-pointer hover:opacity-70"
                  onClick={() => navigate('/integrations')}
                >
                  Back to Integrations
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default MtdCompleteWrapper
